// Field component registry for ChoiceFlow
import CheckboxField from './CheckboxField';
import DropdownMultiSelectField from './DropdownMultiSelectField';
import DropdownSingleSelectField from './DropdownSingleSelectField';
import MultiSelectField from './MultiSelectField';
import NumberField from './NumberField';
import RangeField from './RangeField';
import SingleSelectField from './SingleSelectField';
import TagInputField from './TagInputField';
import TextInputField from './TextInputField';
import WhatToKnowCard from '../../WhatToKnowCard';

/**
 * Registry of field type renderers
 * Each field renderer receives: { def, value, onChange, disabled, error }
 */
export const FIELD_REGISTRY = Object.freeze({
  single_select: SingleSelectField,
  multi_select: MultiSelectField,
  dropdown_single_select: DropdownSingleSelectField,
  dropdown_multi_select: DropdownMultiSelectField,
  range: RangeField,
  text: TextInputField, // Multiline text input (def.multiline = true or type = 'text')
  input: TextInputField, // Single-line text input (def.multiline = false or type = 'input')
  number: NumberField,
  checkbox: CheckboxField,
  tag_input: TagInputField
});

export const COMPONENT_REGISTRY = Object.freeze({
  what_to_know: WhatToKnowCard
});

/**
 * Get a field component by type
 * @param {string} type - Field type
 * @returns {import('react').ComponentType|null} Field component or null if not found
 */
export const getFieldComponent = (type) => {
  const component = FIELD_REGISTRY[type];

  if (!component) {
    console.warn(`[FieldRegistry] Unknown field type: ${type}`);
    return null;
  }

  return component;
};

/**
 * Check if a field type is supported
 * @param {string} type - Field type
 * @returns {boolean} Whether the field type is supported
 */
export const isValidFieldType = (type) => {
  return Object.prototype.hasOwnProperty.call(FIELD_REGISTRY, type);
};

/**
 * Get all supported field types
 * @returns {string[]} Array of supported field types
 */
export const getSupportedFieldTypes = () => {
  return Object.keys(FIELD_REGISTRY);
};
